import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { RouterLink } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { SeoService } from '@out-web/core';

@Component({
  selector: 'out-about',
  imports: [RouterLink, CommonModule],
  templateUrl: './about.component.html',
  styleUrl: './about.component.css',
})
export class AboutComponent implements OnInit {
  constructor(
    private seoService: SeoService,
    public auth: AuthService
  ) { }
  ngOnInit(): void {
    this.setMetaData();
  }

  private setMetaData() {
    const title = 'About Us | Sell Your Tesla | Only Used Tesla';
    const description = 'About Us | Only Used Tesla | A Place Exclusively Dedicated To Buying And Selling Used Teslas';
    const imageUrl = 'https://onlyusedtesla.com/assets/images/meta-logo.png';
    const url = 'https://onlyusedtesla.com/about-only-used-tesla';

    this.seoService.setMetaData(title, description, imageUrl, url);
  }
}
